import { Component } from '@angular/core';
import { GridOptions, GridApi, ColDef, RowSelectionOptions } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { Router } from '@angular/router';
import { agGridDarkTheme } from 'src/app/shared/components/ag-grid/dark-theme';
// models
import { PurchaseHistoryColumnDef } from './columnDefs';
import { DummyDataService } from 'src/app/shared/services/dummy-data/dummy-data.service';


@Component({
  selector: 'app-auto-purchase-history',
  templateUrl: './auto-purchase-history.component.html',
  styleUrls: ['./auto-purchase-history.component.scss'],
  standalone: true,
  imports: [AgGridAngular]
})
export class AutoPurchaseHistoryComponent {
  public rowSelection: RowSelectionOptions = {
    mode: 'singleRow',
    enableSelectionWithoutKeys: true,
    checkboxes: false,
  };
  theme = agGridDarkTheme;

  // ag-grid properties Grid
  gridApi!: GridApi

  columnDefs: ColDef[] = PurchaseHistoryColumnDef;
  defaultColDef;
  detailCellRendererParams: any;
  overlayLoadingTemplate;
  overlayNoRowsTemplate;
  gridOptions: GridOptions = {
    theme: agGridDarkTheme,};
  components: any;

  constructor(
    public dummyDataService: DummyDataService,
    private router: Router
  ) {
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      wrapHeaderText: true,
    };
    this.gridOptions.headerHeight = 40;
    this.gridOptions.rowHeight = 25;
    this.gridOptions.context = { ConfigComponent: this }; // this allows access to component functions
  }
  openInventoryRequestLists() {
    this.router.navigate(['inventory-request-lists']);
  }
}
